<template>
  <svg class="icon-alert-warning" width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Group 215">
      <ellipse id="Ellipse 714" cx="16.3249" cy="16.5545" rx="15.8456" ry="15.5911" fill="#D7541C"/>
      <g id="Group 214">
        <path id="Polygon2" d="M16.3249 6.67334L25.5142 22.3342H7.13547L16.3249 6.67334Z" fill="#EEEDD0"/>
        <path id="Vector1128" d="M16.3601 10.991V16.8908M16.3601 18.8299V20.5628" stroke="#D7541C" stroke-width="2"/>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  name: 'IconAlertWarning'
}
</script>
